import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import video from './components/Video/Video';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="classes.App-header">
          <h1>Simple Video Display</h1>
        </header>
        <div className="center">
          {video()}
        </div>
      </div>
    );
  }
}

export default App;
